import { render } from "./AccountsTable.vue?vue&type=template&id=23a606ab&ts=true"
import script from "./AccountsTable.vue?vue&type=script&lang=tsx"
export * from "./AccountsTable.vue?vue&type=script&lang=tsx"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__